import { render } from "./AccountInformation.vue?vue&type=template&id=87a3ac40&scoped=true"
import script from "./AccountInformation.vue?vue&type=script&lang=js"
export * from "./AccountInformation.vue?vue&type=script&lang=js"

import "./AccountInformation.vue?vue&type=style&index=0&id=87a3ac40&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87a3ac40"]])

export default __exports__